module.exports = __webpack_public_path__ + "img/Stakingfre.5d3b7d0e.png";